import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  alertCrawlWrapper: {
    alignItems: 'center',
    backgroundColor: Theme.alertCrawlRed,
    height: '100%',
    width: '100%',
  },
  changeCityIcon: {
    height: Theme.px(72),
    marginBottom: Theme.px(15),
    width: Theme.px(52),
  },
  changeCityIconContainer: {
    alignItems: 'center',
  },
  middleRowWrapper: {
    marginTop: Theme.px(30),
    paddingHorizontal: Theme.px(90),
  },
  rowWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  tileHeader: {
    paddingBottom: Theme.px(12),
    paddingLeft: Theme.px(36),
  },
  wrapper: {
    paddingBottom: Theme.px(42),
    paddingTop: Theme.px(78),
  },
});
